const red = '#ea5455'
const black = '#333743'
const grey = '#5e626e'
const yellow = '#dcdb29'
const white = '#fff'

const breakpoints = ['767px', '992px', '1200px']

export { red, black, grey, yellow, white, breakpoints }
